import React, { useEffect, useState } from "react";

export const About = (props) => {
  const [isVisible, setIsVisible] = useState(false);

  useEffect(() => {
    const aboutImage = document.getElementById("imagen-about");
    if (!aboutImage) return;

    const observer = new IntersectionObserver(
      (entries) => {
        entries.forEach((entry) => {
          if (entry.isIntersecting) {
            setIsVisible(true);
            observer.disconnect();
          }
        });
      },
      { threshold: 0.1 }
    );

    observer.observe(aboutImage);
    return () => observer.disconnect();
  }, []);

  return (
    <div id="about">
      <div className="container">
        <h2>Acerca de Vial Logistic</h2>
        <div className="row align-items-center">
          <div className="col-xs-12 col-md-6 order-md-1 order-2">
            <div className="about-video">
              <video
                className="video-responsive"
                src="../videos/videoVial.mp4"
                loop
                muted
                controls
                autoPlay
              />
            </div>
          </div>
          <div className="col-xs-12 col-md-6 order-md-2 order-1">
            <div className="about-text">
              <div className="div-imagen-about">
                <img
                  id="imagen-about"
                  className="imagen-logo-about"
                  src="/img/LogoVial.jpeg"
                  alt="LogoVial"
                  style={{
                    opacity: isVisible ? 1 : 0,
                    transition: "opacity 4s ease-in",
                  }}
                />
              </div>
              <p>{props.data ? props.data.paragraph : "loading..."}</p>
              <h3>Elementos permitidos y prohibidos al momento de realizar tu envío internacional:</h3>
              <div className="list-style">
                <div className="row">
                  <div className="col-lg-6 col-sm-6 col-xs-12">
                    <ul>
                      {props.data
                        ? props.data.Why.map((d, i) => (
                            <li key={`${d}-${i}`}>{d}</li>
                          ))
                        : "loading"}
                    </ul>
                  </div>
                  <div className="col-lg-6 col-sm-6 col-xs-12 about-text01">
                    <ul>
                      {props.data
                        ? props.data.Why2.map((d, i) => (
                            <li key={`${d}-${i}`}> {d}</li>
                          ))
                        : "loading"}
                    </ul>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};